import styled from '@emotion/styled/macro';

import { FormWrapper } from '../../Form/Form';

export const Wrapper = styled(FormWrapper)`
  width: 38.875rem;
`;
